@if (content) {
<div class="p-b p-t custom-scrollbar">
    <p class="h3"
       *iCms="'modal_title' of content"></p>

    <custom-dropdown [tables]="content.tables"
                     [dropdownLabel]="content?.dropdown_label || ''"
                     [(selectedCustomTable)]="selectedModal"
                     [customTableToggleId]="tableToggleId"
                     (selectedCustomTableChange)="selectTable($event)" />

    @for (table of content.tables; track $index) {
    @if(selectedModal === table.title) {
    <icms-outlet [components]="table.components" />
    }
    }

    @if(content.enable_how_to_measure){
    <button class="w-12 m-t button-1"
            type="button"
            (click)="parentView.openSidebar('how-to-measure')">
        <span>{{'How to measure' | translate}}</span>
    </button>
    }

    <div class="m-t">
        <icms-outlet [components]="content.bottomComponents" />
    </div>
</div>
}
